import { render } from "./MatchCardDesktop.vue?vue&type=template&id=451a3c48&scoped=true&lang=true"
import script from "./MatchCardDesktop.vue?vue&type=script&lang=js"
export * from "./MatchCardDesktop.vue?vue&type=script&lang=js"

import "./MatchCardDesktop.vue?vue&type=style&index=0&id=451a3c48&lang=scss&scoped=true"

import exportComponent from "/var/lib/buildkite-agent/builds/assemble-builder/assemble-sports/broome-livescores-production-vertical-traffic-light/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-451a3c48"]])

export default __exports__